module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ci-6f06682eaf98960662af030b21caa3b2.svg";